// extracted by mini-css-extract-plugin
module.exports = {"headerQuestion":"styles_headerQuestion___p3ot","wrapperContent":"styles_wrapperContent__phdXe","questionText":"styles_questionText__3Xdn8","content":"styles_content__BE_s_"};